var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVelocitaSider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.93296 18.069C8.11486 18.7069 9.44212 19.0271 10.7849 18.9982C12.1276 18.9693 13.4399 18.5924 14.5933 17.9043C15.7467 17.2161 16.7017 16.2404 17.3649 15.0724C18.0281 13.9045 18.3767 12.5845 18.3767 11.2414C18.3767 9.89831 18.0281 8.57824 17.3649 7.41032C16.7017 6.2424 15.7467 5.26664 14.5933 4.5785C13.4399 3.89037 12.1276 3.51342 10.7849 3.48455C9.44212 3.45568 8.11486 3.77587 6.93296 4.41379M1.62109 7.51724H5.96592M1.62109 14.9655H5.96592M1.62109 11.2414H3.48316M16.2073 5.65517L17.1383 4.72414M10.6211 3.17241V1M10.6211 1H7.82799M10.6211 1H13.4142M13.4142 8.44828L10.3107 11.5517",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVelocitaSider);
export default __webpack_public_path__ + "static/media/velocitaSider.4de23fa00487d3e3d973094e5d3203f7.svg";
export { ForwardRef as ReactComponent };